package tools

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import tk.mallumo.compose.navigation.Navigation

object ScrollStack {
    private val stack = mutableMapOf<String, Pair<Int, Int>>()
    private val canBeSaved = mutableMapOf<String, Boolean>()

    fun store(key: String, index: Int, offset: Int = index, force: Boolean) {
        if (canBeSaved.contains(key) || force) {
            stack[key] = index to offset
            if (!force) canBeSaved.remove(key)
        }
    }

    fun enableSageState(key: String) {
        canBeSaved[key] = true
    }

    fun restore(key: String): Pair<Int, Int>? {
        val out = stack[key]
        stack.remove(key)
        return out
    }
}

fun Navigation.storeScrollState(key: String = "") {
    ScrollStack.enableSageState("${navigationId}:$key")
}

@Composable
fun Navigation.rememberScrollState(
    key: String = "",
    autosave: Boolean = true
): ScrollState {

    val initial = remember {
        ScrollStack.restore("${navigationId}:$key") ?: (0 to 0)
    }
    val state = rememberScrollState(initial.first)
    DisposableEffect(Unit) {
        onDispose {
            ScrollStack.store("${navigationId}:$key", state.value, state.value, autosave)
        }
    }
    return state
}

@Composable
fun Navigation.rememberLazyGridState(key: String = "", autosave: Boolean = true): LazyGridState {

    val initial = remember {
        ScrollStack.restore("${navigationId}:$key") ?: (0 to 0)
    }
    val state = rememberLazyGridState(
        initialFirstVisibleItemIndex = initial.first,
        initialFirstVisibleItemScrollOffset = initial.second
    )
    DisposableEffect(Unit) {
        onDispose {
            ScrollStack.store(
                key = "${navigationId}:$key",
                index = state.firstVisibleItemIndex,
                offset = state.firstVisibleItemScrollOffset, force = autosave
            )
        }
    }
    return state
}

@Composable
fun Navigation.rememberLazyListState(key: String = "", autosave: Boolean = true): LazyListState {

    val initial = remember {
        ScrollStack.restore("${navigationId}:$key") ?: (0 to 0)
    }
    val state = rememberLazyListState(
        initialFirstVisibleItemIndex = initial.first,
        initialFirstVisibleItemScrollOffset = initial.second
    )
    DisposableEffect(Unit) {
        onDispose {
            ScrollStack.store(
                key = "${navigationId}:$key",
                index = state.firstVisibleItemIndex,
                offset = state.firstVisibleItemScrollOffset, force = autosave
            )
        }
    }
    return state
}